import { render, staticRenderFns } from "./PartnershipGroupDetail.vue?vue&type=template&id=afce87ae&"
import script from "./PartnershipGroupDetail.vue?vue&type=script&lang=js&"
export * from "./PartnershipGroupDetail.vue?vue&type=script&lang=js&"
import style0 from "./PartnershipGroupDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports